<template>
  <TableComp
    :headers="headers"
    :name="$t('global.announcements')"
    :status="announcements.status"
    :pagination="announcements.pagination"
    :sort="announcements.sort"
    :number-of-items="announcements.list.length"
    @update:list="updateList"
    :emptyBoldMessage="$t('global.no-announcements-bold-message')"
    emptyImage="announcements"
    :emptyMessage="$t('global.no-announcements-message')"
  >
    <template #desktop>
      <tr v-for="announcement in announcements.list" :key="announcement.id">
        <td>
          <div>
            <router-link :to="{ name: 'announcement-detail', params: { id: announcement.id } }">
              {{ announcement.title }}
            </router-link>
          </div>
        </td>
        <td class="text-end">
          <div class="d-flex justify-content-center">
            {{ dateFormat(announcement.post_date) }}
          </div>
        </td>
      </tr>
    </template>
    <template #mobile>
      <TableMobileRow
        v-for="announcement in announcements.list"
        :key="announcement.id"
        :rows="mobileRows(announcement)"
      >
        <template #header>
          <div class="d-flex align-items-center">
            <div class="flex-fill">
              <router-link :to="{ name: 'announcement-detail', params: { id: announcement.id } }">
                {{ announcement.title }}
              </router-link>
            </div>
          </div>
        </template>
      </TableMobileRow>
    </template>
  </TableComp>
</template>

<script>
import { dateFormat } from "leatherman-js/utils/formatters/time";
import store from "@/store";
import TableComp from "@/components/display/table/TableComp";
import TableHeader from "@/classes/TableHeader";
import TableMobileRow from "@/components/display/table/TableMobileRow";
import { timeSince } from "leatherman-js/utils/formatters/time";

export default {
  name: "announcementsTable",
  props: {
    announcements: Object,
  },
  components: {
    TableComp,
    TableMobileRow,
  },
  setup(props, { root }) {
    const headers = [
      new TableHeader(root.$t("global.description"), null, "title"),
      new TableHeader(root.$t("global.date"), "justify-content-center", "post_date"),
    ];

    const mobileRows = (announcement) => [
      { title: root.$t("global.date"), data: dateFormat(announcement.post_date) },
    ];

    const updateList = (event) => {
      const { pagination, sort } = event;
      store.dispatch("announcements/getList", {
        pageIndex: pagination?.index,
        pageSize: pagination?.size,
        sortProperty: sort?.property,
        sortDirection: sort?.direction,
      });
    };

    return {
      dateFormat,
      headers,
      mobileRows,
      timeSince,
      updateList,
    };
  },
};
</script>
